// ---Third-party imports
import { createAction } from 'redux-actions';
// ---Framework imports
import log from 'uix/logging';
import { COPY2PAYLOAD, SILENT } from 'uix/actions';
// ---Exports
export let loadJobSpec = createAction('LOAD_JOB_SPEC');
export let setJobSpec = createAction('SET_JOB_SPEC', COPY2PAYLOAD);
export let startJob = createAction('START_JOB', (name, params)=>({
        name,
        params
    }));
export let jobCreated = createAction('JOB_CREATED', (job)=>({
        job
    }));
export let stopJob = createAction('STOP_JOB', (ojid, terminate)=>({
        ojid,
        terminate: !!terminate
    }));
export let restartJob = createAction('RESTART_JOB', (ojid)=>({
        ojid
    }));
export let setActiveJobs = createAction('SET_ACTIVE_JOBS', (active)=>({
        active
    }));
// register one job in active array, job = {name, ojid, state}
export let setActiveJob = createAction('SET_ACTIVE_JOB', (job)=>({
        job
    }));
export let updateJobInfo = createAction('UPDATE_JOB_INFO', (jobs)=>({
        jobs: jobs || []
    }), SILENT);
export let deleteJobs = createAction('DELETE_JOBS', (ojids, callback)=>({
        ojids,
        callback
    }));
export let loadJobEvents = createAction('LOAD_JOB_EVENTS', (ojid)=>({
        ojid
    }));
export let setJobEvents = createAction('SET_JOB_EVENTS', (ojid, evdata)=>({
        ojid,
        evdata
    }));
